var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('el-image',{staticClass:"c-custom-mask-img",class:{ 'is-mini': _vm.type === 'mini' },attrs:{"src":_setup.maskImage,"fit":"cover"}})
}
var staticRenderFns = []

export { render, staticRenderFns }